/* eslint-disable max-lines */
import store from '@/store/index';
import _ from 'lodash';
import { config as configStatic } from '../config';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
const { user } = store.getters;
// const formatColumns = () => {
//     const _configStatic = _.cloneDeep(configStatic);
//     const displayNameList = ['customerCode', 'customerName'];
//     return _configStatic.columns.map(it => {
//         if (displayNameList.includes(it.prop)) {
//             it.displayName = it.prop;
//         }
//         it.value = it.label;
//         return it;
//     });
// };
// const formatColumnsProp = () => {
//     const _configStatic = _.cloneDeep(configStatic);
//     return _configStatic.columns.map(it => it.prop);
// };
export const tableConfig = {
    name: 'whiteListFlow',
    columns: [
        {
            label: '客户名称',
            prop: 'customerName',
            // width: 200,
            fixed: 'left'
        },
        {
            label: '客户系',
            prop: 'customerGroupName'
            // width: 140
        },
        {
            label: '行业大类',
            prop: 'industryCategoriesName'
            // width: 140
        },
        {
            label: '细分行业',
            prop: 'industryType',
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE'
            // width: 120
        },
        {
            label: '风险等级',
            prop: 'riskLevel',
            type: 'select',
            optionsKey: 'LMDM_RISKLEVEL'
            // width: 100
        }

    ],
    actions: { // 表格操作列的配置
        fixedWidth: 80, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        displayEditRule: () => {
            return false;
        },
        list: [
            {
                label: '删除',
                event: 'del',
                displayRule: (row) => {
                    return true;
                }
            }
        ]
    },
    whiteListFlowAdvanceParams: {
        advanceLabel: '白名单客户选择',
        label: '白名单客户选择',
        name: '白名单客户选择',
        prop: 'contractCodes',
        value: 'contractCodes',
        labelWidth: '150px',
        dialogWidth: '1200px',
        selection: true,
        type: 'custom',
        focusShowDialog: true,
        noCloseDialog: true,
        visible: true,
        multiple: true,
        border: true,
        disabledDbClick: true,
        firstNoFetch: false,
        advanceConfig: [
            {
                value: '客户编码',
                prop: 'customerCode',
                type: 'input'
            },
            {
                value: '客户名称',
                prop: 'customerName',
                type: 'input'
            }
        ],
        tableConfig: [
            {
                value: '客户编码',
                prop: 'customerCode',
                width: '120px'
            },
            {
                value: '客户名称',
                prop: 'customerName',
                displayName: 'customerName',
                width: '200px'
            },
            {
                value: '客户系',
                prop: 'customerGroupName'
            },
            {
                value: '行业大类',
                prop: 'industryCategoriesName'
            },
            {
                value: '细分行业',
                prop: 'industryType',
                type: 'select',
                optionsKey: 'SYS_INDUSTRY_TYPE',
                width: '80px'
            },
            {
                value: '风险等级',
                prop: 'riskLevel',
                type: 'select',
                optionsKey: 'LMDM_RISKLEVEL'
            },
            {
                value: '客户状态',
                prop: 'customerStatus',
                type: 'select',
                optionsKey: 'SYS_WM_CUSTOMER_STATUS'
            },
            {
                value: '是否白名单',
                prop: 'isWhitelist',
                type: 'select',
                optionsKey: 'SYS_YES_NO',
                width: '90px'
            }
        ],
        MultipleConfig: {
            NoInsertFirstConfig: true,
            method: 'post',
            // prefix: 'pms-template',
            advanceCascade: { param: {} },
            tableConfig: [
                {
                    prop: 'customerName',
                    value: '客户名称'
                }
            ]
        },
        otherMultiple: [{ prop: 'ebcuId' }, { prop: 'customerCode' }, { prop: 'id' }],
        // searchObj: {
        // key: '',
        // keyword: ''
        // },
        prefix: 'api-lcrm',
        method: 'post',
        searchType: 'input',
        advanceUrl: '/customer/info/page',
        splitType: '|-,',
        cbParams: ['ebcuId#id', 'id', 'customerCode', 'customerName', 'customerGroupName', 'industryCategoriesName', 'industryType', 'riskLevel', 'customerStatus',
            'isVirtualCustomer', 'isWhitelist'
        ],
        beforeRequest: (params) => {
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            const page = { ..._.pick(params, ['pageNo', 'pageSize']) };
            const filterCondition = _.omit(params, ['pageNo', 'pageSize', 'orderBy', 'orderByType']);
            // 最新查询条件格式化
            const _params2 = otherUtils.convertObject(filterCondition, configStatic.matchOperator);
            return { ..._params2, ...page };
        },
        afterResponse: (res) => {
            if (res && +res.code === 0 && res.data.list) {
                res.data.list = res.data.list.map(it => {
                    it.id = it.ebcuId;
                    return it;
                });
            }
            return res;
        }
    }
};
